import React, { useContext, useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Pen, PlusCircle, Trash } from 'react-bootstrap-icons';
import { getVariableTableHeaders } from '../../../helpers/constants';
import EntityTable from '../../common/EntityTable';
import { LocalizeContext } from 'react-locale-language';
import { Button as ButtonTW } from '../../ui/button';
import { PenIcon, Trash2 } from 'lucide-react';
const Variables = ({
  variables = [],
  onVariableAddClick,
  onVariableEditClick,
  onVariableDeleteClick,
  readOnlyMode
}) => {
  const { translate, langCode } = useContext(LocalizeContext);
  const variableTableHeaders = useMemo(() => getVariableTableHeaders(translate), [langCode]);

  return (
    <Card>
      <Card.Header>{translate('variables')}</Card.Header>
      <Card.Body>
        <EntityTable
          rowKeyField={'_id'}
          data={variables}
          headers={variableTableHeaders}
          searchQueryKeys={['name']}
          additionalComponents={() =>
            !readOnlyMode && (
              <Button size="sm" className="text-white" variant="success" onClick={onVariableAddClick}>
                <PlusCircle className="mr-1" /> {translate('new_variables')}
              </Button>
            )
          }
          actionCell={item =>
            !readOnlyMode && (
              <div className="d-flex align-items-center gap-2">
                <ButtonTW variant="ghost" className="p-1 me-0 bg-transparent" onClick={() => onVariableEditClick(item)}>
                  <PenIcon size={8} className="text-info" />
                </ButtonTW>
                <ButtonTW
                  variant="ghost"
                  className="p-1 me-0 bg-transparent"
                  onClick={() => {
                    onVariableDeleteClick(item);
                  }}
                >
                  <Trash2 size={8} className="text-red-500" />
                </ButtonTW>
              </div>
            )
          }
        />
      </Card.Body>
    </Card>
  );
};

export default Variables;
